import Classico from '../Assets/menu/classico.png'
import Curry from '../Assets/menu/curry.png'
import Manzo from '../Assets/menu/manzo.png'
import Pollo from '../Assets/menu/pollo.png'
import Verdure from '../Assets/menu/verdure.png'

const menuData = [
    {
        key: 'manzo',
        name: 'Manzo',
        img: Manzo,
    },
    {
        key: 'pollo',
        name: 'Pollo',
        img: Pollo,
    },
    {
        key: 'verdure',
        name: 'Verdure',
        img: Verdure,
    },
    {
        key: 'curry',
        name: 'Curry',
        img: Curry,
    },
    {
        key: 'classico',
        name: 'Yakisoba classico',
        img: Classico,
    }
];

export default menuData;
